import { clsx } from 'clsx'
import { type FC } from 'react'

import { useDeliveryInfoExperiment } from '../../../../../experiments/components/ExperimentDeliveryDatesOTC/ExperimentDeliveryDatesOtc'
import { useGetExperiment } from '../../../../../experiments/hooks'
import { EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS } from '../../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../../experiments/model/EXPERIMENT_VARIATION'
import { productAccessorIsSaeOffer } from '../../../../model/productAccessor/productAccessorIsSaeOffer'
import { useProductPageContext } from '../../../productPageContext'
import { useProductStockStatus } from '../../hooks/useProductStockStatus'

export const ProductBuyBoxStockStatus: FC = () => {
  const productStockStatus = useProductStockStatus()

  // Calling experiment hook
  const { getDeliveryLabelMessage, useActivateDeliveryDatesExperiment } =
    useDeliveryInfoExperiment()

  useActivateDeliveryDatesExperiment()
  const pdpDeliveryOptions = useGetExperiment(
    EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS,
  )

  const { currentOffer } = useProductPageContext()

  const isMarketplace = currentOffer
    ? !productAccessorIsSaeOffer(currentOffer)
    : false

  return (
    <span
      className={
        pdpDeliveryOptions.isEnabled &&
        !isMarketplace &&
        pdpDeliveryOptions.variant !== EXPERIMENT_VARIATION.DEFAULT
          ? 'text-s text-dark-primary-max'
          : clsx('font-medium', productStockStatus.color)
      }
      data-qa-id="product-status-qa-id"
    >
      <div className="py-1">{getDeliveryLabelMessage()}</div>
    </span>
  )
}
